import { Heart, Dumbbell, Sparkles, Briefcase } from "lucide-react";

export const PILLAR_ICONS = {
  cuore: Heart,
  fitness: Dumbbell,
  beauty: Sparkles,
  realizzazione: Briefcase,
};

export function PillarIcon({ pillar, className = "w-5 h-5", ...rest }) {
  const Icon = PILLAR_ICONS[pillar] || Heart;
  return <Icon className={className} {...rest} />;
}
